import { useEffect, useState } from "react";

/**
 * Delay a fast-changing value. Used by the results filter bar so typing in
 * a text filter doesn't re-run the filter+sort pass on every keystroke.
 */
export default function useDebouncedValue(value, delay = 200) {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(timer);
  }, [value, delay]);

  return debounced;
}
